import $ from 'jquery'

export const auto_complete = {
  data() {
    return {
      val: '',
      // items: [],           // 표시할 아이템 목록
      results: [],            //선택된 결과
      text: '',   
      placeHolder: '',   
      selfInput: undefined,
    }
  },
  props: {
    value: String | Number,
    size: {
      type: String,
      default: null
    },
    placeholder: '',
    allowUnselected: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    place_holder: function() {
      return this.placeholder || this.placeHolder;
    }
  },
  watch: {
    value: function(newVal) {
      this.val = newVal;
    }
  },
  created() {
    this.val = this.value;
  },
  mounted() {
    let ariaOwns = $(this.$el).attr('aria-owns');
    this.selfInput = $('[aria-owns="' + ariaOwns + '"] input');
    if (this.allowUnselected) {
      $(this.selfInput).attr('aria-allow-unselected', true);
    }
  },
  methods: {    
    searchQuery(queryString, callback) {      
      let results = queryString ? this.items.filter(this.createFilter(queryString)) : this.items;
      this.results = results;
      callback(results);
    },
    createFilter(queryString) {
      return (item) => {
        return (item.name.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
      };
    },
    searchCode() {
      if (isNaN(this.text)) { return; }
      let item = this.items.find(i => i.code === this.text);
      if (!this.allowUnselected && !item) { return; }
      this.$emit('select', item);
      this.selfInput.attr('aria-selected', true)
    },
    handleInput(text) {
      this.text = text;
      this.selfInput.attr('aria-selected', null)
      this.$emit('select', text);
    },
    handleSelect(item) {      
      this.$emit('select', item);
      this.selfInput.attr('aria-selected', true)
    },
    handleClear() {
      this.$emit('clear', arguments);
      this.selfInput.blur();
    },
  },
}
